export const profile = {
  name: '안태윤',
  bio: {
    role: '소프트웨어 엔지니어',
    description: ['AI와 데이터를 다루는', '로보틱스를 탐구하는', '웹 서비스를 만드는'],
    thumbnail: 'sample.png',
  },
  social: {
    github: 'https://github.com/TaeYunAhn',
    linkedIn: '',
    email: 'ahntaeyun97@gmail.com',
  },
};

// Professional content transcribed from the September 2026 CV.
// Undated awards intentionally have no inferred year.
export const skills = [
  { title: 'AI / Machine Learning', items: ['BERT', 'LightGBM', 'CNN', 'LSTM'] },
  { title: 'Robotics', items: ['ROS2', 'Nav2', 'LiDAR', 'OAK-D', 'Jetson'] },
  {
    title: 'Software Engineering',
    items: ['Python', 'C++', 'FastAPI', 'Java / Spring', 'MySQL', 'Git', 'Docker'],
  },
];

export const experience = [
  {
    title: 'Purdue University',
    date: '2025.06 – 2025.08',
    role: 'Ultrasonic Wildlife Detection · Scholarship',
    details: [
      '초음파 IoT 센서와 엣지 디바이스를 이용한 야생동물 탐지 시스템 개발',
      '동물 존재 여부 분류를 위한 오디오 데이터 수집·라벨링 및 CNN 기반 연구',
    ],
  },
  {
    title: 'Adkick',
    date: '2025.03 – 2025.05',
    role: 'AI 기반 광고주–크리에이터 매칭 플랫폼',
    details: [
      'BERT·LightGBM 기반 매칭 파이프라인과 리뷰 텍스트 분석·가짜 인플루언서 탐지 모델 개발',
      'FastAPI·MySQL 기반 백엔드 API 및 플랫폼 로직 구현, 서비스 기획·시스템 설계 참여',
    ],
  },
  {
    title: 'Dpre',
    date: '2024.09 – 2025.02',
    role: 'ROFA 엔진 웹 서비스 · Matlab 최적화',
    details: [
      '개선된 ROFA 엔진 기반 웹 서비스 개발',
      'CPU/GPU 병렬화와 Matlab 리팩터링으로 실시간 연산 최적화',
    ],
  },
  {
    title: 'Yonsei FinTech Center',
    date: '2023.02 – 2023.08',
    role: 'LPPLS 기반 C++ 구현 · 병렬 연산',
    details: [
      'LPPLS 논문을 바탕으로 Matlab 코드를 C++로 변환',
      'CPU/GPU 병렬화 및 유전 알고리즘(GA)을 포함한 최적화 알고리즘 구현',
    ],
  },
  {
    title: 'UpCyplus',
    date: '2022.02 – 2023.02',
    role: 'Web Engineering',
    details: ['React·JavaScript·HTML·CSS 기반 웹사이트 개발 및 운영'],
  },
  {
    title: 'Yonsei FinTech Center',
    date: '2021.11 – 2021.12',
    role: '데이터 시각화 · 웹 개발',
    details: [
      'Plotly를 이용한 ARM risk·FRM cost 분석 시각화 모델 개발',
      '연세 핀테크 센터 도메인 웹 개발',
    ],
  },
  {
    title: '42 Seoul',
    date: '2021.03 – 2022.04',
    role: 'Software Engineering 교육 · Web Platform Team',
    details: [
      'Java·Spring 기반 건물 출입 모바일 웹의 프론트엔드·백엔드 API 개발',
      '서버 및 Docker 환경 지원',
    ],
  },
  {
    title: 'KISTI',
    date: '2020.09 – 2021.02',
    role: 'AI 논문 텍스트 데이터 구축 인턴',
    details: ['AI 논문 텍스트 데이터 구축 참여'],
  },
];

export const publication = {
  title:
    'Wildlife Detection via 40kHz Ultrasonic Signals: Dataset Design and Deep Learning Evaluation.',
  authors: 'Kang, S., Kang, H., Ahn, S., Ahn, T., Hiday, L., & Smith, A. H.',
  venue:
    '2025 International Conference on Robotic Computing and Communication (RoboticCC 2025), pp. 127–134.',
  doi: '10.1109/RoboticCC68732.2025.00021',
};

export const projects = [
  {
    title: '국민연금공단 산학협력 프로젝트',
    date: '2025.03 – 2025.06',
    description:
      '건강 상태·세제 혜택·개인 연금 데이터를 고려한 최적 연금 수령 전략 추천 시스템 개발',
  },
  {
    title: 'KOSCOM 산학협력 프로젝트',
    date: '2024.09 – 2024.12',
    description: 'LSTM 기반 기술적 분석, 포트폴리오 구성 최적화 및 백엔드 데이터 처리 자동화',
  },
  { title: 'One Fitness', date: '2024.06.01', description: '고객 관리 웹앱 출시' },
  {
    title: 'START FARM',
    date: '2023.08.30',
    description: 'OASIS 해커톤에서 START FARM 플랫폼 개발',
  },
  {
    title: 'LASEK Side Effects Prediction',
    date: '2022.08.04',
    description: '전북대학교 자기설계 공모전 · Random Forest 기반 라섹 부작용 예측 솔루션',
  },
  {
    title: 'URL Shortener',
    date: '2021.11.09',
    description: '42 Seoul 산학협력 오픈소스 소프트웨어 해커톤 · URL 단축 서비스 개발',
  },
  { title: 'we make Piscine', date: '2021.10.25', description: '42 Seoul 해커톤 프로젝트' },
];

export const awards = [
  { date: '2024', title: 'JBNU SW 창업 경진대회', result: '최우수상' },
  { date: '2024', title: '전주 창업 경진대회', result: '우수상' },
  { date: '2024', title: '롯데 신격호 창업 경진대회', result: '장려상·특별상 · 전국 419개 팀' },
  { date: '2024', title: 'JBNU Capstone Design Contest', result: '최우수상' },
  { date: '2024', title: 'JBNU SW Generative AI / Fine-tuning Hackathon', result: '우수상' },
  { date: '2023', title: 'JBNU OpenSource Hackathon', result: '우수상' },
  { date: '2023', title: 'OASIS Hackathon', result: '최우수상 · 전국 21개 팀' },
  {
    date: '',
    title: '아주대학교 아주 소중한 딥러닝 대회',
    result: '3등상 · 전국 70명 · Multimodal Deep Learning',
  },
  {
    date: '',
    title: '전북 도전 혁신 아이디어리그',
    result: '우수상 · 전북 40팀 · Multimodal Deep Learning',
  },
];

export const credentials = [
  { title: 'ADsP', date: '2024.09', detail: '한국데이터산업진흥원' },
  { title: 'SQLD', date: '2024.09', detail: '한국데이터산업진흥원' },
  { title: 'OPIc', date: '2024.03', detail: 'IH' },
];
